module.exports = __webpack_public_path__ + "static/img/MyNetwork-Genealogy.7b2f94c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/backoffice/MyNetwork-Genealogy.png
// module id = wod2
// module chunks = 0